/**
 * 账户模块相关路由
 */
import Layout from '@/views/layout/index.vue'
export default {
  path: '/dataApplication',
  component: Layout,
  redirect: '/analysisTemplate/baseModel',
  name: 'datasource',
  meta: { title: '数据应用', icon: 'example' },
  children: [
    {
      path: '/analysisTemplate/baseModel',
      name: 'baseModel',
      component: () => import('@/views/dataApplication/baseModel'),
      meta: {
        title: 'Dashboard',
        icon: 'account',
        breadcrumb: ['数据应用', '分析模型', 'Dashboard']
      },
    },
    {
      path: '/analysisTemplate/userDefinedModel',
      name: 'userDefinedModel',
      component: () => import('@/views/dataApplication/userDefinedModel'),
      meta: {
        title: '自定义分析',
        icon: 'account',
        breadcrumb: ['数据应用', '分析模型', '自定义分析']
      },
    },
    {
      path: 'smartWarning',
      name: 'smartWarning',
      component: () => import('@/views/dataApplication/smartWarning'),
      meta: {
        title: '智能预警',
        icon: 'account',
        breadcrumb: ['数据应用', '智能预警']
      },
    },
    {
      path: 'downloadCenter',
      name: 'downloadCenter',
      component: () => import('@/views/dataApplication/downloadCenter'),
      meta: {
        title: '下载中心',
        icon: 'account',
        breadcrumb: ['数据应用', '下载中心']
      }
    },
    {
      path: 'chartSubscription',
      name: 'chartSubscription',
      component: () => import('@/views/dataApplication/chartSubscription'),
      meta: {
        title: '图表订阅',
        icon: 'account',
        breadcrumb: ['数据应用',  '图表订阅']
      },
    },
  ],
}
